/**
 * @copyright (C) 2023, Rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of Rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by Rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/
/* eslint @typescript-eslint/no-inferrable-types: 0 */
/* eslint @typescript-eslint/no-explicit-any: 0 */

import CryptoJS from "crypto-js";
import CryptoData from "./cryptodata";

function stringToJSON<T = any>(data: any, defalutValue: T | null = null) {
	try {
		if (typeof data === "string" && (data === "true" || data === "false")) {
			return JSON.parse(data) as T;
		}
		if (typeof data === "string" && (data.trim().startsWith("{") || data.trim().startsWith("["))) {
			return JSON.parse(data) as T;
		}
		return data as T;
	} catch {
		return defalutValue;
	}
}

function JSONToString(data: any) {
	if (data !== null) {
		if (typeof data === "object") {
			return JSON.stringify(data);
		}
		return data;
	} else {
		return null;
	}
}

export class CryptoUtility {
	constructor(
		public cryptoData: CryptoData,
		private _keyData: CryptoJS.lib.WordArray = CryptoJS.PBKDF2(
			cryptoData.passKey,
			CryptoJS.enc.Hex.parse(cryptoData.salt),
			{
				keySize: 512 / 32,
				iterations: cryptoData.count
			}
		)
	) {}

	public encrypt(data: any) {
		return CryptoJS.AES.encrypt(JSONToString(data), this._keyData, {
			iv: CryptoJS.enc.Hex.parse(this.cryptoData.iv)
		}).ciphertext.toString(CryptoJS.enc.Base64);
	}

	public decrypt<T>(data: any) {
		const cipherParams = CryptoJS.lib.CipherParams.create({
			ciphertext: CryptoJS.enc.Base64.parse(data.toString())
		});
		return stringToJSON(
			CryptoJS.AES.decrypt(cipherParams, this._keyData, {
				iv: CryptoJS.enc.Hex.parse(this.cryptoData.iv)
			}).toString(CryptoJS.enc.Utf8)
		) as T;
	}
}

// 일반적인 상황에서 사용할 암호 유틸리티
export const NormalCrypto = new CryptoUtility(
	new CryptoData(
		// bXzwYWUoJo2pxoEHRynRjhqmQFJZoEWnax7rBw
		[
			98, 88, 122, 119, 89, 87, 85, 111, 74, 111, 50, 112, 120, 111, 69, 72, 82, 121, 110, 82, 106, 104, 113, 109,
			81, 70, 74, 90, 111, 69, 87, 110, 97, 120, 55, 114, 66, 119
		],
		// 2764fdcebe4d6759b87d16acc1778e53
		[
			50, 55, 54, 52, 102, 100, 99, 101, 98, 101, 52, 100, 54, 55, 53, 57, 98, 56, 55, 100, 49, 54, 97, 99, 99,
			49, 55, 55, 56, 101, 53, 51
		],
		// 3c2a42c5693453e441826de52f2022e9
		[
			51, 99, 50, 97, 52, 50, 99, 53, 54, 57, 51, 52, 53, 51, 101, 52, 52, 49, 56, 50, 54, 100, 101, 53, 50, 102,
			50, 48, 50, 50, 101, 57
		]
	)
);

// MQTT에서 암호화키 교환시 사용할 암호 유틸리티
export const ExchangeKeyCrypto = new CryptoUtility(
	new CryptoData(
		// Vb!UyMTNQ8HhjjLJB4ZXZ6TiQcX2z73.mNcg_6
		[
			86, 98, 33, 85, 121, 77, 84, 78, 81, 56, 72, 104, 106, 106, 76, 74, 66, 52, 90, 88, 90, 54, 84, 105, 81, 99,
			88, 50, 122, 55, 51, 46, 109, 78, 99, 103, 95, 54
		],
		// NfiDigpxn@V-HqQt3hG*@7d*FFNetVoC
		[
			78, 102, 105, 68, 105, 103, 112, 120, 110, 64, 86, 45, 72, 113, 81, 116, 51, 104, 71, 42, 64, 55, 100, 42,
			70, 70, 78, 101, 116, 86, 111, 67
		],
		// HBLh!YK@WTCXcfhGQiuLuE7M6Rwj_P4E
		[
			72, 66, 76, 104, 33, 89, 75, 64, 87, 84, 67, 88, 99, 102, 104, 71, 81, 105, 117, 76, 117, 69, 55, 77, 54,
			82, 119, 106, 95, 80, 52, 69
		]
	)
);
